export enum PlayerScoreViewAttributes {
  PLAYER_SCORE = 'PLAYER_SCORE',
  PREDICTION = 'PREDICTION',
  OPPONENT = 'OPPONENT',
  MATCHUP = 'MATCHUP',
}
/*
  AB → At Bats = Official batting appearances (excludes walks, hit by pitch, sacrifices, etc.)
  R → Runs = Number of runs scored
  H → Hits = Total hits (singles + doubles + triples + home runs)
  RBI → Runs Batted In = Runs driven in by the player
  HR → Home Runs = Home runs hit
  BB → Base on Balls = Walks (player reaches base on four balls)
  K → Strikeouts = Strikeouts (outs made on strikes)
  AVG → Batting Average = H ÷ AB (ratio of hits per at-bat)
  OBP → On-Base Percentage = (H + BB + HBP) ÷ (AB + BB + HBP) (percentage of times reaching base)
  SLG → Slugging Percentage = Total bases ÷ AB (power hitting measure: 1B=1, 2B=2, 3B=3, HR=4)
*/
export type PlayerScoreStats =
  | AnySportPlayerScoreStats
  | FootballPlayerScoreStats
  | BaseballPlayerScoreStats
  | NBAPlayerScoreStats;

export enum AnySportPlayerScoreStats {
  FORM = 'FORM',
  PRICE = 'PRICE',
  SCORE = 'SCORE',
  PROJECTED_SCORE = 'PROJECTED_SCORE',
}

export enum FootballPlayerScoreStats {
  DS = 'DS',
  AA = 'AA',
}

export enum BaseballPlayerScoreStats {
  TOTAL_SCORE = 'TOTAL_SCORE',
  AB = 'AB',
  R = 'R',
  H = 'H',
  RBI = 'RBI',
  HR = 'HR',
  BB = 'BB',
  K = 'K',
  AVG = 'AVG',
  OBP = 'OBP',
  SLG = 'SLG',
  MATCHUPS = 'MATCHUPS',
  FORM = 'FORM',
  L5 = 'L5',
  L15 = 'L15',
  PRICE = 'PRICE',
}

export enum NBAPlayerScoreStats {
  TOT = 'TOT',
  L10 = 'L10',
  DIFF = 'DIFF.',
  MIN = 'MIN',
  THREE_PT = '3PT',
  REB = 'REB',
  AST = 'AST',
  STL = 'STL',
  BLK = 'BLK',
  TO = 'TO',
  PTS = 'PTS',
  GAMES = 'GAMES',
}

export type PlayerScoreView = {
  [PlayerScoreViewAttributes.PLAYER_SCORE]: PlayerScoreStats[];
  [PlayerScoreViewAttributes.OPPONENT]: PlayerScoreStats[];
};
